import { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { globalTheme } from '@clds/component-theme';
import { useSelectedAsset } from '../../selectors';
import Format from './Format';
import Summary from './Summary';

const PreviewBox = styled.div`
  background: ${(props) => props.theme.palette.surface};
  box-shadow: ${(props) => props.theme.shadow.md};
  flex-grow: 1;
  z-index: 2;
  overflow: auto;
`;

export default ({ selectAssetFormat }) => {
  const dispatch = useDispatch();
  const { selectedAsset, selectedFormat } = useSelectedAsset();

  const handleSelectAssetFormat = useCallback(
    (payload) => {
      dispatch(selectAssetFormat(payload));
    },
    [dispatch, selectAssetFormat]
  );

  return (
    <PreviewBox data-test="purchase-info-section">
      <Format selectedAsset={selectedAsset} selectedFormat={selectedFormat} selectAssetFormat={handleSelectAssetFormat} />
      <Summary selectedAsset={selectedAsset} />
    </PreviewBox>
  );
};
